import { Injectable } from "@angular/core";
import { EndpointFactoryService } from "./endpoint-factory.service";
import { Observable, Subject } from "rxjs";
import * as signalR from "@microsoft/signalr";
import { ILogger, LogLevel } from "@microsoft/signalr";

class CustomSignalRLogger implements ILogger {
  log(logLevel: LogLevel, message: string): void {}
}

@Injectable({
  providedIn: "root",
})
export class SignalRService extends EndpointFactoryService {
  timerId: any = null;
  isConnected = false;
  isConnecting = false;
  private isListenersSet = false;
  hubConnection!: signalR.HubConnection;
  private newReservationRequest = new Subject<number>();
  private newNotification = new Subject<number>();
  private newWithdrawInfo = new Subject<any>();
  private newDepositInfo = new Subject<any>();
  private newCameraInfo = new Subject<any>();
  private newPrinterInfo = new Subject<any>();
  private newPassportInfo = new Subject<any>();
  private readonly url = this.configurations.baseUrl + "/notification";
  private option: signalR.IHttpConnectionOptions = {
    accessTokenFactory: () => this.accessToken,
  };
  getNewCameraEvent(): Observable<any> {
    return this.newCameraInfo.asObservable();
  }
  getNewDepositEvent(): Observable<any> {
    return this.newDepositInfo.asObservable();
  }
  getNewPrinterEvent(): Observable<any> {
    return this.newPrinterInfo.asObservable();
  }
  getNewPassportEvent(): Observable<any> {
    return this.newPassportInfo.asObservable();
  }
  getNewWithdrawEvent(): Observable<any> {
    return this.newWithdrawInfo.asObservable();
  }
  getNewReservationRequestEvent(): Observable<number> {
    return this.newReservationRequest.asObservable();
  }

  getNewNotificationEvent(): Observable<number> {
    return this.newNotification.asObservable();
  }

  init() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.url, this.option)
      .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000])
      .configureLogging(new CustomSignalRLogger())
      .build();
    this.addListeners();
  }

  connect() {
    if (this.isConnected) {
      return;
    }
    this.hubConnection
      .start()
      .then(() => {
        this.isConnected = true;
      })
      .catch((err) => {
        this.isConnected = false;
      });
  }

  disconnect() {
    this.hubConnection.stop().then(() => (this.isConnected = false));
  }

  sendMessage(method: string, data: any) {
    this.hubConnection.send(method, ...[data]).then(
      (r) => {},
      (error) => {
        console.log(error);
      },
    );
  }

  addListeners() {
    if (this.isListenersSet) {
      return;
    }
    this.isListenersSet = true;
    this.hubConnection.onclose(() => {
      this.isConnected = false;
    });
    this.hubConnection.on("onNotification", (id) => {
      this.newNotification.next(id);
    });
    this.hubConnection.on("OnSendCameraInfo", (data) => {
      this.newCameraInfo.next(data);
    });
    this.hubConnection.on("OnSendPrinterInfo", (data) => {
      this.newPrinterInfo.next(data);
    });
    this.hubConnection.on("OnSendWithdrawInfo", (data) => {
      this.newWithdrawInfo.next(data);
    });
    this.hubConnection.on("OnSendDepositInfo", (data) => {
      this.newDepositInfo.next(data);
    });
    this.hubConnection.on("OnSendPassportInfo", (data) => {
      this.newPassportInfo.next(data);
    });
  }
}
